import { Space, TextLoader } from '@procurify/ui'

import { CreateBeneficiaryFormLoadingSkeletonStyled } from '../styles/CreateBeneficiaryFormLoadingSkeletonStyled'

export const CreateBeneficiaryFormSkeleton = () => {
  return (
    <CreateBeneficiaryFormLoadingSkeletonStyled>
      <Space direction='vertical' size='large'>
        <Space direction='vertical' size='xsmall'>
          <TextLoader width={160} height={16} />
          <TextLoader width='100%' height={50} />
        </Space>
        <Space direction='vertical' size='xsmall'>
          <TextLoader width={160} height={16} />
          <TextLoader width='100%' height={50} />
        </Space>
        <Space direction='vertical' size='xsmall'>
          <TextLoader width={160} height={16} />
          <TextLoader width='100%' height={50} />
        </Space>
      </Space>
    </CreateBeneficiaryFormLoadingSkeletonStyled>
  )
}
